export default "__VITE_ASSET__BQWDnWmb__"